import { registerIcon } from "@ui5/webcomponents-base/dist/asset-registries/Icons.js";

const name = "less";
const pathData = "M464 224q16 0 16 16v32q0 16-16 16H48q-6 0-11-4.5T32 272v-32q0-7 5-11.5t11-4.5h416z";
const ltr = false;
const accData = null;
const collection = "SAP-icons";
const packageName = "@ui5/webcomponents-icons";

registerIcon(name, { pathData, ltr, collection, packageName });

export default "SAP-icons/less";
export { pathData, ltr, accData };